// extracted by mini-css-extract-plugin
module.exports = {"shortcuts":"shortcuts_shortcuts__32SMs"};